import Timer from './Timer';
import Game from '../../../Game';
import { IGameState } from '../../../State/Game/IGameState';
import DateHelper from '../../../Utility/DateHelper';
import { dailyLoginTimerDuration } from '../../../Constants/DailyLogin';

export default class SundayOfferTimer extends Timer {
    public duration = dailyLoginTimerDuration;
    public cachedSessionDate = new Date(DateHelper.now.getTime());

    constructor() {
        super();
    }
    public complete(state: IGameState) {
        if (this.onComplete) {
            this.onComplete(state);
        }
    }
    public isCompleted(state: IGameState): boolean {
        return DateHelper.isCompleted(this.getDate(), this.duration);
    }
    public onComplete: (state: IGameState) => unknown;
    public getDate(state: IGameState = Game.store.getState()): Date | null {
        const date: Date = new Date(this.cachedSessionDate.getTime());
        date.setHours(0,0,0,0);
        return date;
    }
}
